// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"608ec6d7","453":"74b70468","667":"2ee27125"}[chunkId] + ".chunk.js";
};